import React, { ReactElement } from 'react';
import { Col, Row } from 'react-bootstrap';
import EnteteDePage from '../Utils/EnteteDePage';
import LogsLoader from '../Utils/Log';

export default function HistoriqueLog(): ReactElement {
    return (
        <>
            <Row>
                <Col>
                    <EnteteDePage texte="Historique des logs" cacherBoutonRetour />
                </Col>
            </Row>
            <LogsLoader noTitle hasElement></LogsLoader>
        </>
    );
}
